import { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import s from './DropdownButton.module.scss';

export default class DropdownButton extends Component {
    static propTypes = {
        showDropdown: PropTypes.bool.isRequired,
        hasMapNoteWritePermission: PropTypes.bool.isRequired,
        hasObjectStoreWritePermission: PropTypes.bool.isRequired,
        onNoteClick: PropTypes.func.isRequired,
        onPointClick: PropTypes.func.isRequired,
        onShowDropdown: PropTypes.func.isRequired,
    };

    onDropdownButtonClick = onClick => button => {
        onClick(button);
        this.props.onShowDropdown(false);
    };

    renderDropdownButton = (label, icon, onClick) => (
        <button className={classNames(s.button, s.dropdownButton)} onClick={onClick} type="button" data-testid={`add-${label}-button`}>
            <img className={s.icon} src={icon} alt={label} />
            <div className={s.label}>{label}</div>
        </button>
    );

    renderModeButtons = () => (
        <div className={s.dropdownButtonsWrapper}>
            <div className={s.dropdownButtonsTop} />
            {this.props.hasMapNoteWritePermission &&
                this.renderDropdownButton('Note', 'https://content.locuslabs.com/vms-ui/map-note-icons/map-notes.svg', this.onDropdownButtonClick(this.props.onNoteClick))}
            {this.props.hasObjectStoreWritePermission &&
                this.renderDropdownButton('POI', 'https://content.locuslabs.com/vms-ui/map-note-icons/location.svg', this.onDropdownButtonClick(this.props.onPointClick))}
            <div className={s.dropdownButtonsBottom} />
        </div>
    );

    render() {
        const { showDropdown } = this.props;
        return (
            <div>
                <button className={classNames({ [s.buttonActive]: showDropdown }, s.button, s.addButton)} onClick={() => this.props.onShowDropdown(!showDropdown)} type="button" data-testid={'map-add-button'}>
                    <div className={classNames('icon-add', s.icon)} />
                    <div className={s.label}>Add</div>
                </button>
                {showDropdown && this.renderModeButtons()}
            </div>
        );
    }
}
